import React, { useState, useEffect } from "react";
import {
  Sidebar,
  Menu,
  MenuItem,
  SubMenu,
  sidebarClasses,
} from "react-pro-sidebar";
import { Link, useLocation } from "react-router-dom";
// import { MdHighQuality } from "react-icons/md";
import { MdManageAccounts, MdPreview } from "react-icons/md";
import "./AdminNav.css";
import {
  UserRoundCog,
  HandCoins,
  WalletCards,
  NotebookTabs,
  House,
  GroupIcon,
  User2Icon,
  Handshake,
  Users,
  HeartHandshake,
  UserRound,
  Building2,
  PersonStanding,
  TextQuote,
  BookCheck,
  Microscope,
  IdCard,
  Palette,
  Tag,
  ShoppingCart,
  BrickWall,
  Factory,
  ShoppingBasket,
  Bomb,
  Slack,
  Radiation,
  Receipt,
  ReceiptIcon,
  Component,
  Scissors,
  LucideScissorsLineDashed,
  SquareBottomDashedScissors,
  ShieldCheck,
} from "lucide-react";

import logoImg from "../../assets/windTree/images/login/logowbg.webp";
import { FaCartArrowDown, FaThinkPeaks } from "react-icons/fa";
import { FileText } from "lucide-react";

import {
  Drawer,
  DrawerBody,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
} from "@chakra-ui/react";
import { getPermissions, getUserId } from "../../utils/IndexDB/PermissionStore";

function AdminNav(props) {
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 576);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [logo, setLogo] = useState(true);
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    setLogo(!logo);
  }, [props.isSidebarCollapsed]);

  useEffect(() => {
    (async () => {
      try {
        const userId = await getUserId();
        if (!userId) return;

        const permissionRes = await getPermissions(userId);
        setPermissions(permissionRes);
      } catch (err) {
        console.log("Permission error:", err);
      }
    })();
  }, []);

  const normalize = (name) => {
    return name?.toLowerCase().replace(/\s+/g, "").trim();
  };

  const hasPermission = (permissions, moduleName) => {
    if (!permissions?.length) return false;

    const found = permissions.find(
      (p) => normalize(p.moduleName) === normalize(moduleName),
    );

    return found?.viewOnly || found?.viewAll;
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 576);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const customMenuItemStyles = {
    button: {
      color: "#00000",
      paddingLeft: 0,
    },
    psMenuButton: {
      marginLeft: "0px !important",
      height: "40px !important",
    },
  };

  const renderMenuContent = () => (
    <>
      <div className="logo-div">
        {/* <span className="">
          <img src={logoImg} alt="logo" />
        </span> */}
        {!logo && (
          <span className="">
            <img src={logoImg} alt="logo" />
          </span>
        )}
      </div>
      <div className="custom-scroll" style={{ maxHeight: "90vh" }}>
        <MenuItem
          icon={<House size={16} />}
          component={<Link to="/admin/dashboard" className="link" />}
          className={
            location.pathname === "/admin/dashboard"
              ? "menu-item active"
              : "menu-item"
          }
        >
          Home
        </MenuItem>

        {hasPermission(permissions, "lead") ||
        hasPermission(permissions, "client") ||
        hasPermission(permissions, "company") ||
        hasPermission(permissions, "deal") ||
        hasPermission(permissions, "Walkthrough") ||
        hasPermission(permissions, "Quotes") ||
        hasPermission(permissions, "task master") ? (
          <SubMenu
            label="CRM"
            className="Menu-label"
            icon={<Handshake size={16} />}
          >
            {hasPermission(permissions, "lead") && (
              <MenuItem
                icon={<Users size={16} />}
                component={<Link to="/admin/crm/lead-list" className="link" />}
                className={
                  location.pathname.startsWith("/admin/crm/lead")
                    ? "menu-item active"
                    : "menu-item"
                }
              >
                Leads
              </MenuItem>
            )}

            {hasPermission(permissions, "client") && (
              <MenuItem
                icon={<UserRound size={16} />}
                component={
                  <Link to="/admin/crm/client-list" className="link" />
                }
                className={
                  location.pathname.startsWith("/admin/client")
                    ? "menu-item active"
                    : "menu-item"
                }
              >
                Client
              </MenuItem>
            )}

            {hasPermission(permissions, "company") && (
              <MenuItem
                icon={<Building2 size={16} />}
                component={
                  <Link to="/admin/crm/company-list" className="link" />
                }
                className={
                  location.pathname.startsWith("/admin/company")
                    ? "menu-item active"
                    : "menu-item"
                }
              >
                Company
              </MenuItem>
            )}

            {hasPermission(permissions, "deal") && (
              <MenuItem
                icon={<HeartHandshake size={16} />}
                component={<Link to="/admin/crm/deal-list" className="link" />}
                className={
                  location.pathname.startsWith("/admin/crm/deal")
                    ? "menu-item active"
                    : "menu-item"
                }
              >
                Deals
              </MenuItem>
            )}

            {hasPermission(permissions, "walkthrough") && (
              <MenuItem
                icon={<PersonStanding size={16} />}
                component={
                  <Link to="/admin/crm/walkthrough-list" className="link" />
                }
                className={
                  location.pathname.startsWith("/admin/walkthrough")
                    ? "menu-item active"
                    : "menu-item"
                }
              >
                Walkthrough
              </MenuItem>
            )}

            {hasPermission(permissions, "quote") && (
              <MenuItem
                icon={<TextQuote size={16} />}
                component={<Link to="/admin/crm/quote-list" className="link" />}
                className={
                  location.pathname.startsWith("/admin/quote")
                    ? "menu-item active"
                    : "menu-item"
                }
              >
                Quotes
              </MenuItem>
            )}

            {hasPermission(permissions, "task master") && (
              <MenuItem
                icon={<BookCheck size={16} />}
                component={
                  <Link to="/admin/crm/taskmaster-list" className="link" />
                }
                className={
                  location.pathname.startsWith("/admin/taskmaster")
                    ? "menu-item active"
                    : "menu-item"
                }
              >
                Task Master
              </MenuItem>
            )}
          </SubMenu>
        ) : null}

        <SubMenu
          label="Sales"
          className="Menu-label"
          icon={<HandCoins size={16} />}
        >
          {hasPermission(permissions, "orders") && (
            <MenuItem
              icon={<WalletCards size={16} />}
              component={<Link to="/admin/sales/order-list" className="link" />}
              className={
                location.pathname.startsWith("/admin/sales/order") ||
                location.pathname.startsWith("/admin/sales/add-order-form")
                  ? "menu-item active"
                  : "menu-item"
              }
            >
              Orders
            </MenuItem>
          )}

          <MenuItem
            icon={<User2Icon size={16} />}
            component={<Link to="/admin/sales/vendor-list" className="link" />}
            className={
              location.pathname.startsWith("/admin/sales/vendor") ||
              location.pathname.startsWith("/admin/sales/vendor-form")
                ? "menu-item active"
                : "menu-item"
            }
          >
            Vendor
          </MenuItem>
          <MenuItem
            icon={<WalletCards size={16} />}
            component={
              <Link to="/admin/sales/purchaseOrder-list" className="link" />
            }
            className={
              location.pathname.startsWith("/admin/sales/purchaseOrder") ||
              location.pathname.startsWith("/admin/sales/purchaseOrder-form")
                ? "menu-item active"
                : "menu-item"
            }
          >
            Purchase Orders
          </MenuItem>
          {/* <MenuItem
            icon={<IdCard size={16} />}
            component={<Link to="/admin/job-cards" className='link' />}
            className={location.pathname === "/admin/jobcard-list" ? "menu-item active" : "menu-item"}
          >
            Job Card
          </MenuItem> */}
          {/* <MenuItem icon={<WalletCards size={16} />} component={<Link to="/admin/bulky-order-list" className='link' />} className={location.pathname === "/admin/bulky-order-list" ? "menu-item active" : "menu-item"}>
            Bulky Orders
          </MenuItem> */}
          {/* <MenuItem icon={<UserRoundCog size={16} />} component={<Link to="/admin/customer-list" className='link ' />} className={location.pathname === "/admin/customer-list" ? "menu-item active" : "menu-item"}>
            Customers
          </MenuItem> */}
        </SubMenu>

        {hasPermission(permissions, "shade") ||
        hasPermission(permissions, "item") ||
        hasPermission(permissions, "category") ||
        hasPermission(permissions, "bom") ||
        // hasPermission(permissions, "raw material") ||
        hasPermission(permissions, "product review") ? (
          <SubMenu label="Inventory" icon={<UserRoundCog size={16} />}>
            {/* <MenuItem icon={<FaLandmark size={16} />} component={<Link to="/admin/add-brand" className='link' />} className={location.pathname === "/admin/add-brand" ? "menu-item active" : "menu-item"}>
            Add Brand
          </MenuItem> */}
            {/* <MenuItem icon={<Tag />}
            component={<Link to="/admin/label-list" className="link" />}
            className={location.pathname === "/admin/label-list" ? "menu-item active" : "menu-item"}>Label</MenuItem> */}
            {hasPermission(permissions, "raw material") && (
              <MenuItem
                icon={<Component size={16} />}
                component={
                  <Link
                    to="/admin/inventory/raw-material-list"
                    className="link"
                  />
                }
                className={
                  location.pathname.startsWith(
                    "/admin/inventory/raw-material-list",
                  ) ||
                  location.pathname.startsWith(
                    "/admin/inventory/raw-material-detail",
                  ) ||
                  location.pathname.startsWith(
                    "/admin/inventory/raw-material-form",
                  )
                    ? "menu-item active"
                    : "menu-item"
                }
              >
                Raw Material
              </MenuItem>
            )}
            {hasPermission(permissions, "shade") && (
              <MenuItem
                icon={<Palette />}
                component={
                  <Link to="/admin/inventory/shade-list" className="link" />
                }
                className={
                  location.pathname.startsWith("/admin/shade")
                    ? "menu-item active"
                    : "menu-item"
                }
              >
                Shades
              </MenuItem>
            )}

            {hasPermission(permissions, "item") && (
              <MenuItem
                icon={<FaCartArrowDown size={16} />}
                component={
                  <Link to="/admin/inventory/product-list" className="link" />
                }
                className={
                  location.pathname.startsWith(
                    "/admin/inventory/product-list",
                  ) ||
                  location.pathname.startsWith(
                    "/admin/inventory/product-detail",
                  ) ||
                  location.pathname.startsWith(
                    "/admin/inventory/add-product-form",
                  )
                    ? "menu-item active"
                    : "menu-item"
                }
              >
                Mechanism
              </MenuItem>
            )}

            {hasPermission(permissions, "category") && (
              <MenuItem
                icon={<GroupIcon size={16} />}
                component={
                  <Link to="/admin/inventory/collection" className="link" />
                }
                className={
                  location.pathname.startsWith("/admin/inventory/collection")
                    ? "menu-item active"
                    : "menu-item"
                }
              >
                Finish Goods
              </MenuItem>
            )}

            {hasPermission(permissions, "bom") && (
              <MenuItem
                icon={<Slack size={16} />}
                component={
                  <Link to="/admin/inventory/bom-list" className="link" />
                }
                className={
                  location.pathname.startsWith("/admin/inventory/bom")
                    ? "menu-item active"
                    : "menu-item"
                }
              >
                BOM
              </MenuItem>
            )}

            {/* <MenuItem icon={<CompassIcon size={16} />} component={<Link to="/admin/brand-master" className='link' />} className={location.pathname === "/admin/brand-master" ? "menu-item active" : "menu-item"}>
            Brand Master
            </MenuItem>  */}

            {hasPermission(permissions, "product review") && (
              <MenuItem
                icon={<MdPreview size={16} />}
                component={
                  <Link to="/admin/inventory/product-review" className="link" />
                }
                className={
                  location.pathname.startsWith(
                    "/admin/inventory/product-review",
                  ) ||
                  location.pathname.startsWith(
                    "/admin/inventory/product-review-form",
                  )
                    ? "menu-item active"
                    : "menu-item"
                }
              >
                Product Review
              </MenuItem>
            )}
          </SubMenu>
        ) : null}

        {/* <SubMenu label="Purchases" className="Menu-label" icon={<HandCoins size={16} />}>
          <MenuItem
            icon={<User2Icon size={16} />}
            component={<Link to="/admin/vendor-list" className='link' />}
            className={location.pathname === "/admin/vendor-list" ? "menu-item active" : "menu-item"}
          >
            Vendor
          </MenuItem>
          <MenuItem
            icon={<WalletCards size={16} />}
            component={<Link to="/admin/purchaseOrder-list" className='link' />}
            className={location.pathname === "/admin/purchaseOrder-list" ? "menu-item active" : "menu-item"}
          >
            Purchase Orders
          </MenuItem>
          <MenuItem
            icon={<WalletCards size={16} />}
            component={<Link to="purchase" className='link' />}
            className={location.pathname === "purchase" ? "menu-item active" : "menu-item"}
          >
            Purchase Receive
          </MenuItem>

           <MenuItem icon={<ShoppingBasket size={16} />} component={<Link to="/admin/purchaseRequisition-list" className='link' />}
            className={location.pathname === "/admin/purchaseRequisition-list" ? "menu-item active" : "menu-item"}>Purchase Requisition</MenuItem>

        </SubMenu> */}

        {hasPermission(permissions, "prepare job card") ||
        hasPermission(permissions, "job card") ||
        // hasPermission(permissions, "production order") ||
        hasPermission(permissions, "production batch") ? (
          <SubMenu
            label="Operation"
            className="Menu-label"
            icon={<Factory size={16} />}
          >
            <SubMenu
              label="Planning"
              className="Menu-label"
              icon={<FaThinkPeaks size={16} />}
            >
              {/* Add Prepare Job Card as the first menu item */}

              {hasPermission(permissions, "prepare job card") && (
                <MenuItem
                  icon={<FileText size={16} />}
                  component={
                    <Link
                      to="/admin/production/prepare-jobcard"
                      className="link"
                    />
                  }
                  className={
                    location.pathname.startsWith("/admin/production/prepare") ||
                    location.pathname.startsWith("/admin/production/Prepare")
                      ? "menu-item active"
                      : "menu-item"
                  }
                >
                  Prepare Job Card
                </MenuItem>
              )}
              {hasPermission(permissions, "job card") && (
                <MenuItem
                  icon={<IdCard size={16} />}
                  component={
                    <Link
                      to="/admin/production/jobcard-list"
                      className="link"
                    />
                  }
                  className={
                    location.pathname.startsWith("/admin/production/jobcard")
                      ? "menu-item active"
                      : "menu-item"
                  }
                >
                  Job Card
                </MenuItem>
              )}

              {/* {hasPermission(permissions, "production order") && (
              <MenuItem icon={<ShoppingCart size={16} />} component={<Link to="/admin/production/productionOrder-list" className='link' />}
                className={location.pathname.startsWith("/admin/production/productionOrder") ? "menu-item active" : "menu-item"}>
                Production Order
              </MenuItem>
            )} */}

              {hasPermission(permissions, "production batch") && (
                <MenuItem
                  icon={<Radiation size={16} />}
                  component={
                    <Link
                      to="/admin/production/productionBatch-list"
                      className="link"
                    />
                  }
                  className={
                    location.pathname.startsWith(
                      "/admin/production/productionBatch",
                    )
                      ? "menu-item active"
                      : "menu-item"
                  }
                >
                  Production Batch
                </MenuItem>
              )}
              {/* <MenuItem icon={<BrickWall size={16} />} component={<Link to="/admin/materialRequest-list" className='link' />} */}
              {/* <MenuItem
                icon={<Radiation size={16} />}
                component={
                  <Link to="/admin/production/printing-plan" className="link" />
                }
              >
                Printing-Plan
              </MenuItem> */}
              <MenuItem
                icon={<Radiation size={16} />}
                component={
                  <Link to="/admin/production/printing-list" className="link" />
                }
              >
                Printing
              </MenuItem>

              <MenuItem
                icon={<SquareBottomDashedScissors size={16} />}
                component={
                  <Link
                    to="/admin/production/fabric-cutting"
                    className="link"
                  />
                }
              >
                Fabric Cutting
              </MenuItem>

              <MenuItem
                icon={<LucideScissorsLineDashed size={16} />}
                component={
                  <Link
                    to="/admin/production/channel-cutting"
                    className="link"
                  />
                }
              >
                Channel Cutting
              </MenuItem>

              <MenuItem
                icon={<ShieldCheck size={16} />}
                component={
                  <Link to="/admin/production/Assembely" className="link" />
                }
              >
                Assembely
              </MenuItem>

              {/* className={location.pathname === "/admin/materialRequest-list" ? "menu-item active" : "menu-item"}>Material Request</MenuItem> */}
              {/* <MenuItem icon={<ShoppingBasket size={16} />} component={<Link to="/admin/purchaseRequisition-list" className='link' />}
            className={location.pathname === "/admin/purchaseRequisition-list" ? "menu-item active" : "menu-item"}>Purchase Requisition</MenuItem> */}
              {/* <MenuItem icon={<Slack size={16} />} component={<Link to="/admin/bom-list" className='link' />}
            className={location.pathname === "/admin/bom-list" ? "menu-item active" : "menu-item"}>BOM</MenuItem> */}
            </SubMenu>
          </SubMenu>
        ) : null}

        {hasPermission(permissions, "warehouse management") ||
        hasPermission(permissions, "material request") ? (
          <SubMenu
            label="Warehouse Management"
            className="Menu-label"
            icon={<MdManageAccounts size={16} />}
          >
            {hasPermission(permissions, "production warehouse") && (
              <MenuItem
                icon={<IdCard size={16} />}
                component={
                  <Link
                    to="/admin/production/production-warehouse-list"
                    className="link"
                  />
                }
                className={
                  location.pathname.startsWith(
                    "/admin/production/production-warehouse-list",
                  )
                    ? "menu-item active"
                    : "menu-item"
                }
              >
                Production Warehouse
              </MenuItem>
            )}

            {hasPermission(permissions, "material request") && (
              <MenuItem
                icon={<BrickWall size={16} />}
                component={
                  <Link
                    to="/admin/production/materialRequest-list"
                    className="link"
                  />
                }
                className={
                  location.pathname.startsWith(
                    "/admin/production/materialRequest",
                  )
                    ? "menu-item active"
                    : "menu-item"
                }
              >
                Material Request
              </MenuItem>
            )}
          </SubMenu>
        ) : null}

        {/* <SubMenu label="Operations" className="Menu-label" icon={<Microscope size={16} />}> */}
        {/* <MenuItem
            icon={<IdCard size={16} />}
            component={<Link to="/admin/jobcard-list" className='link' />}
            className={location.pathname === "/admin/jobcard-list" ? "menu-item active" : "menu-item"}
          >
            Job Card
          </MenuItem> */}
        {/* </SubMenu> */}

        {hasPermission(permissions, "label") && (
          <MenuItem
            icon={<Tag />}
            component={
              <Link to="/admin/production/label-list" className="link" />
            }
            className={
              location.pathname.startsWith("/admin/production/label")
                ? "menu-item active"
                : "menu-item"
            }
          >
            Label
          </MenuItem>
        )}

        {hasPermission(permissions, "tag master") && (
          <MenuItem
            icon={<NotebookTabs size={16} />}
            component={<Link to="/admin/tag-master" className="link" />}
            className={
              location.pathname.startsWith("/admin/tag-master")
                ? "menu-item active"
                : "menu-item"
            }
          >
            Tag Master
          </MenuItem>
        )}

        {hasPermission(permissions, "bill") && (
          <MenuItem
            icon={<ReceiptIcon size={16} />}
            component={<Link to="/admin/Billing-list" className="link" />}
            className={
              location.pathname.startsWith("/admin/Billing") ||
              location.pathname.startsWith("/admin/billing")
                ? "menu-item active"
                : "menu-item"
            }
          >
            Bill
          </MenuItem>
        )}

        {/* <a href="https://1713-vancouver-auto-parts-854161632.development.catalystserverless.com/app/index.html" target="_blank" rel="noopener noreferrer" className='link'>
          <MenuItem icon={<LayoutList size={16} />}>Online Store</MenuItem>
        </a> */}
        {/* 
        <SubMenu label="Website Panel" className="Menu-label" icon={<HandCoins size={16} />}>
          <MenuItem icon={<WalletCards size={16} />} component={<Link to="/admin/add-category" className='link' />} className={location.pathname === "/admin/add-category" ? "menu-item active" : "menu-item"}>
            Blog Category
          </MenuItem>
          <MenuItem icon={<WalletCards size={16} />} component={<Link to="/admin/add-blog" className='link' />} className={location.pathname.startsWith("/admin/add-blog")	|| location.pathname.startsWith("/admin/blog-form") ? "menu-item active" : "menu-item"}>
            Blog
          </MenuItem> 
          
        </SubMenu> */}

        {/* <SubMenu label="Policy" className="Menu-label" icon={<Album size={16} />}>
          <MenuItem icon={<WalletCards size={16} />} component={<Link to="/admin/privacy-list" className='link' />} className={location.pathname === "/admin/add-category" ? "menu-item active" : "menu-item"}>
            Privacy Policy
          </MenuItem>

        </SubMenu> */}
      </div>
    </>
  );

  return (
    <>
      {isMobile ? (
        <>
          {/* <button
            className="position-fixed top-50 start-0 m-2 btn btn-light"
            onClick={() => props.setMobileMenuOpen(true)}
            style={{ zIndex: 9999, transform: 'translateY(-50%)', backgroundColor: 'red', border: '2px solid black' }}
          >
            <MenuIcon size={24} />
          </button> */}
          <Drawer
            isOpen={props.mobileMenuOpen}
            placement="left"
            onClose={() => props.setMobileMenuOpen(false)}
            size="xs"
          >
            <DrawerOverlay />
            <DrawerContent>
              <DrawerCloseButton />
              <DrawerBody>
                <Menu menuItemStyles={customMenuItemStyles}>
                  {renderMenuContent()}
                </Menu>
              </DrawerBody>
            </DrawerContent>
          </Drawer>
        </>
      ) : (
        <div style={{ height: "100vh" }}>
          <Sidebar
            collapsed={props.isSidebarCollapsed}
            width="200px"
            collapsedWidth="40px"
            rootStyles={{
              [`.${sidebarClasses.container}`]: {
                backgroundColor: "#dff7eb",
                color: "#011638",
                minHeight: "100vh",
              },
            }}
          >
            <Menu menuItemStyles={customMenuItemStyles}>
              {renderMenuContent()}
            </Menu>
          </Sidebar>
        </div>
      )}
    </>
  );
}

export default AdminNav;
